var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hrmarketing',{attrs:{"getTopics":_vm.getTopicsList,"getPageDetails":_vm.getMarketingDetails,"getWebinars":_vm.getRecentWebinars,"getPocs":_vm.getMarketingPoC}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }